import { ReactElement, useState } from 'react'
import { colors } from '../../../const/theme'
import { Question } from '../../../redux/test/type'
import { Body, H3, Span } from '../../../typography'
import {
  TestResultsHeader,
  ResultsWrapper,
  AnswerSection
} from './subcomponents'
import strings from '../../../locale/en'
import ObjectiveTest from '../Test/ObjectiveTest'
import JumpToQuestions from '../Test/JunpToQuestions'

interface TestResultsProps {
  questions: Array<Question>
}

const TestResults = ({ questions }: TestResultsProps): ReactElement => {
  const [currentQuestion, setCurrentQuestion] = useState(0)
  const question: Question = questions[currentQuestion]
  const {
    submittedAnswered = '',
    correctAnswer = '',
    wrongMarks = -2,
    unAnsweredMarks = -2,
    correctMarks = 4,
    difficultyLevel = '',
    timeSpent = 0,
    timeSpentByTopper = 0
  } = question || {}
  const isAnswerCorrect =
    submittedAnswered?.toLocaleLowerCase() ===
    correctAnswer?.toLocaleLowerCase()
  const incorrectMark = submittedAnswered ? wrongMarks : unAnsweredMarks
  const marks = isAnswerCorrect ? correctMarks : incorrectMark

  return (
    <>
      <TestResultsHeader>
        <ResultsWrapper>
          <H3 color={colors.black}>{`${strings.test.question} ${
            currentQuestion + 1
          }`}</H3>
        </ResultsWrapper>
        <ResultsWrapper>
          <Body color={colors.black}>{`${strings.test.yourAnswer}`}</Body>
          <Body color={isAnswerCorrect ? colors.limeGreen : colors.red}>
            {`${submittedAnswered} (${
              isAnswerCorrect ? 'Correct' : 'InCorrect'
            } ${marks} marks)`}
          </Body>
        </ResultsWrapper>
        <ResultsWrapper>
          <Body color={colors.black}>
            {strings.test.difficultyLevel}
            <Span>{difficultyLevel}</Span>
          </Body>
        </ResultsWrapper>
        <ResultsWrapper>
          <Body color={colors.black}>
            {`${strings.test.timeTakenByYou}: `}
            <Span color={colors.safetyYellow}>{`${timeSpent}s`}</Span>
          </Body>
          <Body color={colors.black}>
            {`${strings.test.timeTakenByTopper}: `}
            <Span color={colors.stateBlue}>{`${timeSpentByTopper}s`}</Span>
          </Body>
        </ResultsWrapper>
      </TestResultsHeader>
      <AnswerSection>
        <ObjectiveTest question={question} isResults />
        <JumpToQuestions
          isResults
          quesionList={questions}
          question={question}
          onClickHandler={(id) => {
            const index = questions.findIndex((qtn) => qtn?.id === id)
            setCurrentQuestion(index)
          }}
        />
      </AnswerSection>
    </>
  )
}

export default TestResults
